import type { RouteRecordRaw } from 'vue-router';

import { onboardingStrategyReadyGuard } from '@/modules/onboarding/router/onboardingStrategyReady.guard';

const EmptyLayout = () => import('@/shared/layouts/pages/EmptyLayout/index.vue');
const Onboarding = () => import('@/modules/onboarding/pages/Onboarding/index.vue');
const InvitationStepsView = () => import('@/modules/miniOnboarding/pages/InvitationSteps/index.vue');
const Shareholders = () => import('@/modules/onboarding/pages/Shareholders/index.vue');
const ShareholdersDeclarationColombia = () => import('@/modules/onboarding/pages/ShareholdersDeclaration/index.vue');

const onboardingRoutes: Array<RouteRecordRaw> = [
  {
    path: '/onboarding',
    name: 'onboarding',
    redirect: {
      name: 'onboarding-index',
    },
    component: EmptyLayout,
    children: [
      {
        path: '',
        name: 'onboarding-index',
        component: Onboarding,
        beforeEnter: onboardingStrategyReadyGuard,
      },
      {
        path: 'invitation',
        name: 'onboarding-invitation',
        component: InvitationStepsView,
      },
      {
        path: 'shareholders',
        name: 'shareholders-declaration',
        component: Shareholders,
      },
      {
        path: 'shareholders-colombia',
        name: 'shareholders-declaration-colombia',
        component: ShareholdersDeclarationColombia,
      },
    ],
  },
];

export default onboardingRoutes;
